import type { ClipboardEvent } from "react"

export function getImageFilesFromClipboard(event: ClipboardEvent): File[] {
  const clipboardData = event.clipboardData
  if (!clipboardData) return []

  const files: File[] = []

  // Check clipboard items
  for (const item of clipboardData.items) {
    if (item.type.startsWith("image/")) {
      const file = item.getAsFile()
      if (file) {
        files.push(file)
      }
    }
  }

  // Fallback: check files directly
  if (files.length === 0) {
    const fileList = clipboardData.files
    for (const file of fileList) {
      if (file.type.startsWith("image/")) {
        files.push(file)
      }
    }
  }

  return files
}
